export class LoginCommand {
    constructor(public userName: string,
                public password: string) {
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/commands/auth/login.command.ts